import TEXT, { HTMLELEMENT, text } from '../../DOM/text/TEXT.js';
/** A PRE element */
export default class PRE extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.PRE, model);
    }
}
export { text };
